<template>
  <div>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      persistent
      max-width="1000px"
    >
      <!--begin::Modal dialog-->
      <div class="bg-white poppins">
        <!--begin::Modal header-->
        <div class="modal-header py-4 align-center">
          <h4 class="mb-0 font-weight-bolder">Edit Payment Gateways</h4>
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-light-info"
            @click="dialog = false"
          >
            <span class="svg-icon">
              <v-icon size="22">mdi-close</v-icon>
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--begin::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
          <!--begin::Body-->
          <form id="createForm" class="pa-3 pb-0">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <template v-for="n in steps">
                  <v-stepper-step
                    :key="`${n}-step`"
                    :complete="e1 > n"
                    :step="n"
                  >
                    <span>{{ getStepperTitle(n) }}</span>
                  </v-stepper-step>

                  <v-divider v-if="n !== steps" :key="n"></v-divider>
                </template>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content :step="1" :key="`1-content`">
                  <div
                    class="justify-content-between stepper-container flex-column d-flex"
                  >
                    <div>
                      <v-autocomplete
                        v-model="form.store_id"
                        :items="stores"
                        outlined
                        item-text="text"
                        item-value="index"
                        dense
                        clearables
                        label="Select Store*"
                      ></v-autocomplete>
                      <v-autocomplete
                        v-model="form.gateways"
                        :items="payment_gateways"
                        outlined
                        item-text="name"
                        item-value="id"
                        dense
                        clearables
                        multiple
                        chips
                        small-chips
                        deletable-chips
                        label="Select Gateways"
                      ></v-autocomplete>
                    </div>

                    <!-- <span class="danger" v-if="$v.formData.gateways.$error">
                      Error Gateways</span
                    > -->
                    <div class="stepper-footer">
                      <div></div>
                      <button
                        type="button"
                        class="btn btn-info px-5 py-3 ls1"
                        @click="nextStep(1)"
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </v-stepper-content>
                <v-stepper-content
                  v-for="(item, key) in steps - 1"
                  :step="key + 2"
                  :key="`${key + 2}-content`"
                >
                  <detail-gateway-form
                    v-if="confirmed"
                    :data="getDetailData(key)"
                    :edit_data="getEditDetailData(key)"
                    :country_selection_conditions="country_selection_conditions"
                    type="edit"
                    :is_submit="key + 2 == steps"
                    :nextStep="nextStep"
                    :page="key + 2"
                    :submit="submit"
                    :previewStep="previewStep"
                    :storeGateway="storeGateway"
                  ></detail-gateway-form>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </form>

          <!--end::Body-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal dialog-->
    </v-dialog>
  </div>
</template>

<script>
import { getToken } from "@/core/services/jwt.service";
import axios from "axios";
import Swal from "sweetalert2";
import DetailGatewayForm from "./DetailGatewayForm";

export default {
  name: "AddItem",
  components: { DetailGatewayForm },
  props: ["loader", "refresher"],
  data: () => ({
    dialog: false,
    form: {
      store_id: null,
      gateways: [],
    },
    gateways: [],
    e1: 1,
    confirmed: false,
  }),
  computed: {
    stores() {
      return this.$store.getters.getPAYMENTSEditData.stores;
    },
    payment_gateways() {
      return this.$store.getters.getPAYMENTSEditData.payment_gateways;
    },
    country_selection_conditions() {
      return this.$store.getters.getPAYMENTSEditData
        .country_selection_conditions;
    },
    initial_data() {
      return this.$store.getters.getPAYMENTSEditData.store_gateways;
    },
    steps() {
      return 1 + this.form.gateways.length;
    },
  },
  methods: {
    toggleModal() {
      this.resetData();
      this.dialog = !this.dialog;
    },
    closeModal() {
      this.dialog = false;
    },
    resetData() {
      this.form.store_id = this.initial_data.store.id;
      this.form.gateways = this.initial_data.gateways.map(
        (value) => value.payment_gateway_id
      );
      this.gateways = [];
      this.confirmed = false;
      this.e1 = 1;
    },
    getStepperTitle(n) {
      if (n == 1 || !this.payment_gateways) return "Setting";
      else
        return (
          this.payment_gateways.find(
            (item) => item.id == this.form.gateways[n - 2]
          ).name + " Setting"
        );
    },
    getDetailData(n) {
      return this.payment_gateways.find(
        (item) => item.id == this.form.gateways[n]
      );
    },
    getEditDetailData(n) {
      return this.initial_data.gateways.find(
        (item) => item.payment_gateway_id == this.form.gateways[n]
      );
    },
    nextStep(page) {
      if (page == 1) {
        if (!this.form.store_id || this.form.gateways.length == 0) {
          this.errorMessage("Please select store and gateways!");
        } else {
          this.confirmed = true;
          this.e1 = page + 1;
        }
      } else if (page == this.steps) {
        this.submit();
      } else {
        this.e1 = page + 1;
      }
    },
    previewStep(n) {
      if (n == 1) this.el = this.steps;
      else this.e1 = n - 1;
    },
    storeGateway(page, gateway) {
      // this.gateways.push(gateway);
      this.gateways[page - 2] = gateway;
    },
    errorMessage(message) {
      Swal.fire({
        title: "Error",
        text: message,
        icon: "error",
        showConfirmButton: false,
        timer: 2500,
      });
    },
    submit() {
      this.loader(true);
      const updateUrl = `${process.env.VUE_APP_BASE_URL}/stores/portal/payments/update`;
      let config = {
        method: "post",
        url: `${updateUrl}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        data: {
          store_id: this.form.store_id,
          gateways: this.gateways,
        },
      };
      axios(config)
        .then(() => {
          this.loader(false);
          Swal.fire({
            title: "Updated",
            text: `New payment has been Updated`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.refresher();
          this.$forceUpdate();
        })
        .catch(() => {
          this.errorMessage("Something went wrong!");
          this.loader(false);
          this.loader(false);
        });
    },
  },
};
</script>
